import type { Dispatch, SetStateAction } from "react";
import { getCurrentTime, getToday } from "./portal/helper";
import {
  calculateTax,
  calculateTaxPerConsignment,
  getDay,
  PaymentEnum,
} from "tools/functions/Methods";

interface ConsignmentProps {
  setShow?: Dispatch<SetStateAction<boolean>>;
  item: any;
}

function SingleConsignment({ item }: ConsignmentProps) {
  const receiverInfo = item.receiverAndConsignmentInfo[0]?.receiverInfo;
  const consignmentInfo = item.receiverAndConsignmentInfo[0]?.consignmentInfo;

  const renderEmpty = (item) => {
    return item || 0;
  };

  const priceFormat = (price) => {
    return price ? (+price)?.toLocaleString() +  "ریال " : "0";
  };

  return (
    <>
      <table id="header-table" className="border   w-full">
        <tbody>
          <tr>
            <td>تاریخ چاپ :{getToday()}</td>
            <td className="head">رسید فرستنده</td>
          </tr>
          <tr>
            <td>زمان چاپ: {getCurrentTime()}</td>
            <td></td>
            <td className="logotext">باکسیت</td>
          </tr>
        </tbody>
      </table>
      <table id="my-table" className="border  w-full">
        <tbody>
          <tr>
            <td colSpan={2}>
              نام گیرنده: {receiverInfo?.name}
              <br />
              <br />
              تلفن: {renderEmpty(receiverInfo?.telephone)}
              <br />
              <br />
              مقصد: {receiverInfo.destination}
            </td>
            <td colSpan={2}>
              نام فرستنده : {item?.senderInfo?.name}
              <br />
              <br />
              تلفن: {item?.senderInfo?.telephone}
              <br />
              <br />
              آدرس برگشت:
              {item.senderInfo.returnAddress}
              {/* {item?.senderDetails?.selectCity?.text
                ?.replaceAll(/[a-z]/gi, "")
                .replaceAll(/[0-9]/g, "")
                .replaceAll("-", "")
                .replaceAll("_", "")
                .trim("")}
              {" - "}
              {removePerantes(item?.returnDestination) ||
                removePerantes(item?.senderAddressName) ||
                removePerantes(item?.pickupHubAddress)} */}
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <td className="right">هزینه بسته بندی:</td>
              <td className="left">{priceFormat(consignmentInfo.packagingCost)}</td>
              <br />
              <br />
              هزینه خدمات: {priceFormat(consignmentInfo?.servicesCost)}
              <br />
              <br />
              جمع هزینه:
              {priceFormat(+item?.sumOfServicesCosts)}
              
              <br />
              <br />
              مالیات بر ارزش افزوده: {priceFormat(item.valueAddedTax)}
              
              <br />
              <br />
              مبلغ تخفیف:{" "}
              {priceFormat(
                 item?.discountAmount
              )}
              
              <br />
              <br />
              هزینه خدمات جانبی: {priceFormat(item?.sideServicesAmount)}
              
              <br />
              <br />
              مبلغ کل: {priceFormat(item?.totalAmount)}
              <br />
              <br />
              <td>
                <b>وجه امانی: </b>
                {priceFormat(consignmentInfo.custodialAmount)}
              </td>
              <br />
              <br />
              {` نحوه پرداخت: ${consignmentInfo.wayOfPayment}`}
            </td>
            <td colSpan={2} dir="rtl">
              {consignmentInfo.consignmentNumber} :کد مرسوله
              <br />
              <br />
              نوع مرسوله: {consignmentInfo.type}
              <br />
              <br />
              {consignmentInfo.packagingSize
                ? ` سایز بسته بندی: ${consignmentInfo.packagingSize}`
                : "___  : سایز بسته بندی"}
              <br />
              <br />
              {consignmentInfo.weight} : (KG) وزن
              <br />
              <br />
              ارزش اظهار شده:{" "}
              {priceFormat(consignmentInfo.declaredValue)} 
              <br />
              <br />
              {consignmentInfo.content
                ? `محتویات : ${consignmentInfo.content}`
                : "___ : محتویات"}
              <br />
              <br />
              نوع خدمت: {consignmentInfo.serviceType}
              <br />
              <br />
              تاریخ و زمان تحویل: {getDay(consignmentInfo.deliveryDateTime)} ساعت:{" "}
              {consignmentInfo.deliveryDateTime?.hour}:{consignmentInfo.deliveryDateTime?.minute}
            </td>
          </tr>
        </tbody>
      </table>
      <table hidden id="footer-table" className="border  w-full">
        <tbody>
          <tr>
            <td>
              نام نمایندگی: {item.hubName}
              <br />
              <br />
              {item?.hubCode} : کد نمایندگی
            </td>
            <td> {"https://boxit.ir"} :رهگیری مرسوله از طریق سایت </td>
          </tr>
        </tbody>
      </table>
    </>
  );
}

export default SingleConsignment;
